<template>
    <div>
        <div class="panel-tag mt-2">
            {{__t("GOOGLE_LOCATION_PARAMS")}}
        </div>

        <div class="form-group mt-4 pt-4 mb-4 pb-4">
            <b-overlay :show="is_load">
                <label class="form-label" for="glovo_location">
                    {{__t("GOOGLE_REST")}}*
                </label>

                <div class="" v-if="ext_restaurants.length > 0">
                    <v-select
                        v-model="general_fields.store_id"
                        class="imc_reasons"
                        :reduce="item => String(item.provider_id)"
                        label="provider_name"
                        :filter="searchRest"
                        :options="this.ext_restaurants"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>{{option.location_name}}</div>
                                <div> {{ option.provider_name }}</div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';

export default {
    name: "google_review_params",
    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            ext_restaurants : [],
            auth_ext : [],
            is_load : false,
            is_load_connect : false,
            has_own : false,
        }
    },

    components : {
        vSelect
    },

    mounted() {
        this.get_locations();
    },

    methods : {

        check_if_exist() {
            if(this.general_fields.hasOwnProperty("id")) {
                if(parseInt(this.general_fields.id) > 0) {
                    this.get_locations();
                }
            }
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'provider_id','provider_name'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async get_locations() {
            this.ext_restaurants = [];
            this.is_load_connect = true;
            await review_api.post('/reviews/sources/60/ext_locations').then(({data}) => {
                if (data.status === "operation_success") {
                    this.ext_restaurants = data.data;
                }
                this.is_load_connect = false;
            }).catch(({response}) => {
                this.is_load_connect = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {

        general_fields() {
            if (this.location.hasOwnProperty("general_fields")) {
                return this.location.general_fields;
            }

            return {
                "id" : 0,
                "username" : "",
                "password" : "",
                "store_id" : null,
            }
        }
    }
}
</script>



<style scoped>

</style>
